import React from 'react';

import { MenuReorderCard } from 'features/menu/components/menu-reorder-widget/menu-reorder-card';
import { contentStyles } from 'features/menu/components/menu-reorder-widget/menu-reorder-details-drawer/styled';
import { MenuReorderDetailsDrawerProps } from 'features/menu/components/menu-reorder-widget/menu-reorder-details-drawer/types';
import { MenuReorderItemsList } from 'features/menu/components/menu-reorder-widget/menu-reorder-items-list';

import { BottomSheet } from 'components/bottom-sheet';
import { Box } from 'components/ui';

export const MenuReorderDetailsDrawer = ({
  showDrawer,
  toggleDetailsDrawer,
  order,
  openDetailEventMessage,
}: MenuReorderDetailsDrawerProps) => {
  return (
    <BottomSheet
      onOpenEventMessage={openDetailEventMessage}
      isOpen={showDrawer}
      onClose={toggleDetailsDrawer}
    >
      <Box style={contentStyles.content}>
        <MenuReorderItemsList
          orderEntries={order.orderEntries}
          ListHeaderComponent={() => (
            <MenuReorderCard
              order={order}
              toggleDetailsDrawer={toggleDetailsDrawer}
              drawerIsOpen={showDrawer}
            />
          )}
        />
      </Box>
    </BottomSheet>
  );
};
